// extracted by mini-css-extract-plugin
export default {"props":"ExternalServicesSelector_props__xBm9R","placeHolderShimmer":"ExternalServicesSelector_placeHolderShimmer__VsjGT"};